import { Component, Input, OnInit } from '@angular/core';
import { min } from 'rxjs/operator/min';
import { ApiService, AuthService, SessionService } from '../../../services';
import { UscStoreService } from '../../../services/usc-store/usc-store.service';

@Component({
    selector: 'sn-usc-notification',
    templateUrl: './usc-notification.component.html',
    styleUrls: ['./usc-notification.component.css']
})
export class UscNotificationComponent implements OnInit {
    @Input() notification_type: string;

    public assignment_messages: any[] = [];
    public deal_assignments: any[] = [];

    constructor(
        public uscStoreService: UscStoreService,
        public authService: AuthService,
        public apiService: ApiService,
        public sessionService: SessionService,
    ) { }

    ngOnInit() {
        this.authService.currentUser.subscribe(
            user => {
                // if (this.notification_type == this.uscStoreService.notification_type_deal_assignment) {
                this.uscStoreService.assignmentMessages.subscribe(messages => {
                    if (messages) {
                        var msg_time = (new Date()).getTime();
                        //var assignment_messages = this.getAssignmentMessageWithoutTime();
                        messages.forEach(m => {
                            var match = this.assignment_messages.find(a => a.fcmMessageId == m.fcmMessageId);
                            // add new assignment_message
                            if (match == null) {
                                var msg = JSON.parse(JSON.stringify(m));
                                msg.time = msg_time;  // set the start time for usage in timer
                                this.assignment_messages.push(msg);
                            }
                        })
                        this.deal_assignments = this.getDealAssignments();
                    }
                });
                // }
            }
        )
    }

    getAssignmentMessageWithoutTime() {
        var messages = [];
        for (var i = 0; i < this.assignment_messages.length; i++) {
            var msg = JSON.parse(JSON.stringify(this.assignment_messages[i]));
            delete msg.time;
            messages.push(msg);
        }
        return messages;
    }

    getDealAssignments(): any[] {
        var deal_assignments = [];
        this.assignment_messages.forEach(m => {
            var actions = JSON.parse(m.data.actions);
            var assignment_types = ["ts_deal_assignment", "qtrac_assignment"];
            var assignment = actions.find(a => assignment_types.indexOf(a.detail.cmd_sub_type) >= 0);
            if (assignment) {
                assignment.time = m.time;
                if (this.isQtracAssignment(assignment)) {
                    if (assignment.detail.dl_customer) { } else { assignment.detail.dl_type = '[No Customer]' };
                    if (assignment.detail.dl_reason_for_visit) { } else { assignment.detail.dl_reason_for_visit = '[No Reason]' };
                }
                deal_assignments.push(assignment);
            }
        })
        return deal_assignments;
    }

    isNotificationType(type) {
        return this.notification_type == type;
    }

    isTimerEnabled(assignment): boolean {
        return (assignment.detail.expiry_date != null);
    }

    allowInfo(assignment): boolean {
        return assignment.detail.cmd_sub_type == 'qtrac_assignment';
    }

    getTitle(assignment): string {
        if (assignment.detail.cmd_title) return assignment.detail.cmd_title;
        return 'A lead has been assigned to you';
    }

    getExpiryDate(assignment) {
        var date = new Date(assignment.detail.expiry_date);
        var hours = date.getHours();
        var minutes = (date.getMinutes() < 10) ? '0' + date.getMinutes().toString() : date.getMinutes();
        var tt = (hours >= 12) ? "PM" : "AM";
        if (hours == 0) hours = 12;
        if (hours > 12) hours -= 12;
        return `${hours}:${minutes} ${tt}`;
    }

    getTimerStyle(assignment) {
        var start_time = assignment.time;
        var now_time = (new Date()).getTime();
        var expiry_time = new Date(assignment.detail.expiry_date).getTime();
        var total_time = expiry_time - start_time;
        var remaining_time = expiry_time - now_time;
        var time_pct = remaining_time / total_time * 100;
        var colors = ['#cc3232', '#d5772b', '#dfae14', '#93bb3d', '#2cc335'];
        var background_color = '';
        if (time_pct > 0) background_color = colors[0];
        if (time_pct > 20) background_color = colors[1];
        if (time_pct > 40) background_color = colors[2];
        if (time_pct > 60) background_color = colors[3];
        if (time_pct > 80) background_color = colors[4];
        let style: any = { width: time_pct + '%', 'background-color': background_color, border: 'none' };
        if (remaining_time < 0) {
            style.display = 'none';
            this.onTimeout(assignment);
        }
        return style;
    }

    removeAssignment(assignment): any {
        var message, assignment;
        for (var i = 0; i < this.deal_assignments.length; i++) {
            if (this.deal_assignments[i] == assignment) {
                message = this.assignment_messages[i];
                this.assignment_messages.splice(i, 1);
                break;
            }
        }
        if (message) {
            delete message.time;
            this.deal_assignments = this.getDealAssignments();
            this.uscStoreService.removeAssignmentMessage(message);
        }
        return assignment;
    }

    isQtracAssignment(assignment) {
        return assignment.detail.cmd_sub_type == 'qtrac_assignment';
    }

    onAccept(assignment) {
        this.removeAssignment(assignment);
        if (this.isQtracAssignment(assignment)) {
            this.acceptAppointment(assignment); 
        } else {
            this.processAssigmentAction(this.uscStoreService.action_deal_assignment_accepted, assignment);
        }
    }

    onReject(assignment) {
        this.removeAssignment(assignment);
        if (!this.isQtracAssignment(assignment)) {
            this.processAssigmentAction(this.uscStoreService.action_deal_assignment_rejected, assignment);
        }
    }

    onTimeout(assignment) {
        this.removeAssignment(assignment);
        if (!this.isQtracAssignment(assignment)) {
            this.processAssigmentAction(this.uscStoreService.action_deal_assignment_timeout, assignment);
        }
    }

    acceptAppointment(assignment) {
        this.uscStoreService.processActionOnViewItem(this.uscStoreService.view_search, assignment.detail.item_ID, this.uscStoreService.action_accept_appointment, "").subscribe(
            result => {
                if (result) {
                    this.sessionService.log("deal assignment accepted");
                    //this.uscStoreService.setTriggerChatItemReload();                          // trigger chat reload in case the deal is being restored from archive
                    //this.uscStoreService.setViewItemUpdated(item, true);                      // trigger deal update for chat to get the latest changes
                    // let goToItem: any = { dl_type: result.data.type, dl_ID: result.data.ID };
                    // this.uscStoreService.setGotoItem(goToItem);
                }
            }
        );
    }

    processAssigmentAction(action, assignment) {
        var data = { "Deal ID": assignment.detail.item_ID };
        this.apiService.processDealAction(action, data, "raw").subscribe(
            result => {
                this.sessionService.log("assignment action completed", result);
            }, error => {
                this.sessionService.log("unable to process assignment action");
            }
        );
    }

    public formatContactNumber(phone:string) {
        var formatted = "[No Phone #]";
        if (phone && phone.length == 10) {
            formatted = phone.substring(0, 3) + '-' + phone.substring(3, 6) + '-' + phone.substring(6, 10);
        }
        return formatted;
    }

    onCancel() {

    }
}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-store/usc-notification/usc-notification.component.ts